module.exports = __webpack_public_path__ + "static/media/spring-text-logo.1c143e13.svg";